import { compactPrice } from "@/helpers/compactPrice";

export const shortDate = (value) => {
  if (!value) return null;
  const date = new Date(`${String(value).slice(0, 10)}T12:00:00Z`);
  return date.toLocaleDateString("en-US", { month: "short", day: "numeric", timeZone: "UTC" }).replace(" ", "\u00a0");
};


const lastEvidenceDate = (win) => {
  const dates = (win.evidence || []).map((event) => event.at).filter(Boolean).sort();
  return dates.length ? dates[dates.length - 1] : null;
};

export const winStatus = (win) => {
  if (win.kind === "client") return "New client";
  if (win.closeDate) return "Closed";
  if (win.contractDate) return "Under contract";
  return "Matched";
};

export const winDate = (win) => win.closeDate || win.contractDate || win.date || lastEvidenceDate(win);



export const askWhen = (win) => {
  const date = shortDate(winDate(win));
  return (date ? `${winStatus(win)} ${date}` : winStatus(win)).replace(/ /g, "\u00a0");
};

export const winsSummary = (wins) => {
  const volume = wins.reduce((sum, win) => sum + (win.closeDate ? Number(win.closePrice) || 0 : 0), 0);
  return [
    { key: "wins", label: "Wins", value: wins.length },
    { key: "volume", label: "Closed volume", value: volume > 0 ? compactPrice(volume) : "$0" },
    { key: "contract", label: "Under contract", value: wins.filter((win) => win.contractDate && !win.closeDate).length },
  ];
};

export const byNewest = (a, b) => String(winDate(b) || "").localeCompare(String(winDate(a) || ""));

